import { StyleProps, SystemStyleObject } from '@chakra-ui/react';
import {
  getTypographyToken,
  ColorMode,
} from '@allergan-data-labs/alle-elements-core';
import { ToastVariant } from './toast';

export const getToastVariantStyles = (
  variant: ToastVariant,
  colorMode: ColorMode
): StyleProps => {
  const baseStyles = {
    ...getTypographyToken('Body/Medium/Regular'),
    display: 'flex',
    py: 12,
    px: 16,
    boxShadow: 'Elevation/4',
    borderRadius: 'Small',
    minW: '288px',
    maxW: '1024px',
    minH: '56px',
  };

  const variants = {
    success: {
      bg: `${colorMode}.Container/Status/Success bold 1`,
      color: `${colorMode}.Text/Neutral/Inverted`,
    },
    alert: {
      bg: `${colorMode}.Container/Status/Warning medium 3`,
      color: `${colorMode}.Text/Neutral/Default`,
    },
    error: {
      bg: `${colorMode}.Container/Status/Error medium 3`,
      color: `${colorMode}.Text/Neutral/Inverted`,
    },
    neutral: {
      bg: `${colorMode}.Container/Brand/Subtle 1`,
      color: `${colorMode}.Text/Neutral/Default`,
    },
  };

  return {
    ...baseStyles,
    ...variants[variant],
    boxSizing: 'border-box',
    overflowWrap: 'break-word',
  };
};

export const getToastFlexStyle = (): SystemStyleObject => ({
  width: '100%',
  alignItems: 'center',
  gap: '8px',
});

export const getToastRenderFlexStyle = (): SystemStyleObject => ({
  marginRight: 'auto',
});
